import React, { FunctionComponent, useMemo } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import Tag from '../FeatureStory/Tag';

export type Tags = {
  tags?: {
    title?: string;
  }[];
};

const Tags: FunctionComponent<Tags> = (props) => {
  const { tags = [] } = props;

  const Chips = useMemo(() => tags.map((tag, index) => <Tag key={index}>{tag.title}</Tag>), [tags]);

  if (!Chips.length) {
    return null;
  }
  return (
    <Flex margin={[0, -1]} flexDirection="row" flexWrap="wrap">
      {Chips}
    </Flex>
  );
};

export default Tags;
